import {
  SHOPIFY_AG1_POUCH_SINGLE_WELCOME_KIT,
  SHOPIFY_AG1_POUCH_DOUBLE_WELCOME_KIT,
  SHOPIFY_TRAVEL_PACK_SINGLE_WELCOME_KIT,
  SHOPIFY_TRAVEL_PACK_DOUBLE_WELCOME_KIT,
  SHOPIFY_AGZ_WELCOME_KIT_VARIANT_ID
} from '@portal/config/base';
import { StoreCode } from '@portal/schema/storeCode';
import { includesVariant } from './includesVariant';

export const isSubscriptionWelcomeKit = (variantId: string, store: StoreCode) => {
  return (
    includesVariant(variantId, SHOPIFY_AG1_POUCH_SINGLE_WELCOME_KIT[store]) ||
    includesVariant(variantId, SHOPIFY_AG1_POUCH_DOUBLE_WELCOME_KIT[store]) ||
    includesVariant(variantId, SHOPIFY_TRAVEL_PACK_SINGLE_WELCOME_KIT[store]) ||
    includesVariant(variantId, SHOPIFY_TRAVEL_PACK_DOUBLE_WELCOME_KIT[store]) ||
    includesVariant(variantId, SHOPIFY_AGZ_WELCOME_KIT_VARIANT_ID[store])
  );
};
